import { render, staticRenderFns } from "./AnimalLink.vue?vue&type=template&id=286f9de3&scoped=true&"
import script from "./AnimalLink.vue?vue&type=script&lang=js&"
export * from "./AnimalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f9de3",
  null
  
)

export default component.exports